export default __webpack_public_path__ + "img/request.f1c0308a.svg";